import { movingSidePanelSignal, staticSidePanelSignal } from "../Layout"
import IconCross from "../../../../assets/icons/icon-cross-white.svg"
import { useSignals } from "@preact/signals-react/runtime"
import { Button } from "react-aria-components"
import { useLocation } from "react-router"
import * as Navigation from "../../../../modules/Navigation";

const animationType = {
    slide: "slide",
    popOver: "pop-over",
    none: "no-anim"
}

export function handleCloseSidePanel() {
    movingSidePanelSignal.value = { ...movingSidePanelSignal.value, show: false, id: undefined }
}

export default function SidePanel({ show, children }: any) {

    useSignals()
    const { pathname } = useLocation()
    const animationType = getAnimType(pathname)

    const showCloseButton = !pathname.includes(Navigation.CreateRecalls.to)

    return (
        <div id='side-panel' className="side-panel">
            <div className={`side-panel ${animationType}--animation ${animationType} ${show ? `${animationType}--open` : `${animationType}--closed`}`} data-testid={"side-panel"}>
                <div className="side-panel__wrapper">
                    {showCloseButton && <Button data-testid={"side-panel-close"} className="side-panel__cross" onPress={handleCloseSidePanel}>
                        <img src={IconCross} />
                    </Button>}
                    {children}
                </div>
            </div>
        </div>
    )
}

function getAnimType(pathname: string) {
    if (!!staticSidePanelSignal.value) {
        return animationType.popOver
    }
    if (pathname.includes(Navigation.CreateRecalls.to)) {
        return animationType.none
    }

    return animationType.slide
}